module.exports = __webpack_public_path__ + "img/team.e862df7d.png";